<template>
  <div>
    <flip-countdown  :labels="labels" deadline="2024-11-29 08:00:00" @timeElapsed="timeElapsedHandler"></flip-countdown>
  </div>
</template>

<script>
import FlipCountdown from "vue2-flip-countdown";

export default {
  name: "Countdown",
  components: { FlipCountdown },
  data() {
    return {
      labels: { days: "Dias", hours: "Horas", minutes: "Minutos", seconds: "Segundos" }
    };
  }
};
</script>

<style lang="scss">
.flip-card__top,
.flip-card__bottom,
.flip-card__back-bottom,
.flip-card__back::before,
.flip-card__back::after {
  color: #d40000 !important;
  background: rgba(255, 255, 255, 0.9) !important;
}

.flip-card__bottom {
  box-shadow: rgba(212, 0, 0, 0.32) 0px 5px 15px;
}

@media (max-width: 960px) {
  .flip-card,
  .flip-card__top,
  .flip-card__bottom,
  .flip-card__back-bottom,
  .flip-card__back::before,
  .flip-card__back::after {
    color: #ffffff !important;
    background: rgba(212, 0, 0, 0.9) !important;
  }

  .flip-card__back::before,
  .flip-card__back::after {
    background: #aa0000;
  }

  .flip-card__bottom {
    box-shadow: none;
  }
}
</style>
